import {
  Sparkles, Code2, Smartphone, Apple, MonitorSmartphone, Workflow,
} from "lucide-react";

export const SITE = {
  name: "Tech Siksha",
  tagline: "Learn Technology. Build Skills. Stay Ahead.",
  // Contact details
  email: "creator.techsiksha@gmail.com",
  phone: "+91 63038 22850",
  whatsapp: "916303822850", // digits only for wa.me link
  location: "Hyderabad, India",
  socials: {
    instagram: "https://www.instagram.com/tech_siksha/?__pwa=1",
    youtube: "https://www.youtube.com/@Tech_Sikshaa",
    facebook: "https://www.facebook.com/profile.php?id=61584498788428",
  },
};

export const IMAGES = {
  heroAbstract:
    "https://images.unsplash.com/photo-1777789061994-5c13b0ac4993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGVhbiUyMGFic3RyYWN0JTIwdGVjaG5vbG9neSUyMGJsdWUlMjBjeWFufGVufDB8fHx8MTc4NTY2NTc5Nnww&ixlib=rb-4.1.0&q=85",
  aiTools:
    "https://images.unsplash.com/photo-1770210217380-d78a69acdc77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhaSUyMHRlY2hub2xvZ3klMjBhYnN0cmFjdCUyMGRhdGElMjAzZHxlbnwwfHx8fDE3ODU2NjU3OTZ8MA&ixlib=rb-4.1.0&q=85",
  websiteDev:
    "https://images.unsplash.com/photo-1758857087595-aab7fd0a9940?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwbWluaW1hbGlzdCUyMGRlc2slMjB3b3Jrc3BhY2UlMjBhcHBsZSUyMHRlY2h8ZW58MHx8fHwxNzg1NjY1Nzk2fDA&ixlib=rb-4.1.0&q=85",
  mobileTips:
    "https://images.unsplash.com/photo-1760462787855-0a33a4e4751e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwbWluaW1hbGlzdCUyMGRlc2slMjB3b3Jrc3BhY2UlMjBhcHBsZSUyMHRlY2h8ZW58MHx8fHwxNzg1NjY1Nzk2fDA&ixlib=rb-4.1.0&q=85",
  automation:
    "https://images.unsplash.com/photo-1757466762489-52fea38071ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhaSUyMHRlY2hub2xvZ3klMjBhYnN0cmFjdCUyMGRhdGElMjAzZHxlbnwwfHx8fDE3ODU2NjU3OTZ8MA&ixlib=rb-4.1.0&q=85",
  workFromHome:
    "https://images.unsplash.com/photo-1776919017122-8140e279c889?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwbWluaW1hbGlzdCUyMGRlc2slMjB3b3Jrc3BhY2UlMjBhcHBsZSUyMHRlY2h8ZW58MHx8fHwxNzg1NjY1Nzk2fDA&ixlib=rb-4.1.0&q=85",
};

export const TOPIC_LIST = [
  {
    slug: "ai-tools",
    title: "AI Tools",
    icon: Sparkles,
    desc: "Curated AI tools and workflows that save hours every week.",
  },
  {
    slug: "website-development",
    title: "Website Development",
    icon: Code2,
    desc: "Build modern, fast websites with clean, scalable code.",
  },
  {
    slug: "android-tips",
    title: "Android Tips",
    icon: Smartphone,
    desc: "Hidden features, tweaks and apps to master your Android.",
  },
  {
    slug: "iphone-tips",
    title: "iPhone Tips",
    icon: Apple,
    desc: "Get more from iOS with practical, everyday iPhone tricks.",
  },
  {
    slug: "pc-tips",
    title: "PC Tips",
    icon: MonitorSmartphone,
    desc: "Speed up, secure and optimise your Windows or Mac PC.",
  },
  {
    slug: "business-automation",
    title: "Business Automation",
    icon: Workflow,
    desc: "Automate repetitive tasks and scale your work smarter.",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Practical over theoretical",
    body: "Every tutorial, review and guide is built to be used today — no fluff, just results you can apply immediately.",
  },
  {
    no: "02",
    title: "Simplify modern technology",
    body: "From AI tools to automation, we translate complex tech into clear, actionable steps for creators and businesses.",
  },
  {
    no: "03",
    title: "Grow with a community",
    body: "Tech Shiksha keeps publishing resources, downloads and reviews so you always stay one step ahead.",
  },
];

export const MARQUEE_ITEMS = [
  "AI Tools", "Website Development", "Android", "iPhone", "PC Tips",
  "Automation", "Productivity", "Digital Skills", "Reviews", "Tutorials",
];
